import axios, { AxiosResponse } from 'axios'

import { RequestQuery } from '@models/apiBase'
import { Response } from '@models/apiBase'
import { ResponseSuccess } from '@models/apiBase'
import { WithFilter } from '@models/apiBase'
import { ID } from '@models/base'
import { QueueCounterModel } from '@models/queueCounter'

import { API_URL } from '@/constants/constant'

const QUEUE_COUNTERS_URL = `${API_URL}/queue-counters`

type ResponseQueueCounter = Response<{
  queue_counter: QueueCounterModel
}>
type ResponseQueueCounters = Response<WithFilter<Array<QueueCounterModel>>>

export type PayloadCreateQueueCounter = {
  clinic_printer_id: ID
  name: string
  queue_id: ID
  is_active: boolean
}
export type PayloadUpdateQueueCounter = {
  clinic_printer_id: ID
  name: string
  is_active: boolean
}
export type PayloadOptionForCheckIn = {
  queue_id: ID
}

interface IQueueCountersAPI {
  create: (payload: PayloadCreateQueueCounter) => Promise<ResponseQueueCounter>

  update: (id: ID, payload: PayloadUpdateQueueCounter) => Promise<ResponseQueueCounter>

  getOptionsForQueueNumberCompleteForm: (query: RequestQuery, queueId: ID) => Promise<ResponseQueueCounters>

  getOptionsForQueueNumberGenerateForm: (query: RequestQuery, queueId: ID) => Promise<ResponseQueueCounters>

  getOptionsForCheckIn: (payload: PayloadOptionForCheckIn) => Promise<ResponseQueueCounters>

  checkIn: (id: ID) => Promise<ResponseSuccess>

  checkOut: () => Promise<ResponseSuccess>
}

export const QueueCountersAPI: IQueueCountersAPI = {
  create: async (payload) => {
    return axios.post(`${QUEUE_COUNTERS_URL}`, payload).then((r: AxiosResponse) => r.data)
  },

  update: async (id, payload) => {
    return axios.put(`${QUEUE_COUNTERS_URL}/${id}`, payload).then((r: AxiosResponse) => r.data)
  },

  getOptionsForQueueNumberCompleteForm: async (query, queueId) => {
    return axios
      .post(`${QUEUE_COUNTERS_URL}/options/queue-number-complete-form`, {
        queue_id: queueId,
        ...query,
      })
      .then((r: AxiosResponse) => r.data)
  },

  getOptionsForQueueNumberGenerateForm: async (query, queueId) => {
    return axios
      .post(`${QUEUE_COUNTERS_URL}/options/queue-number-generate-form`, {
        queue_id: queueId,
        ...query,
      })
      .then((r: AxiosResponse) => r.data)
  },

  getOptionsForCheckIn: async (payload) => {
    return axios.post(`${QUEUE_COUNTERS_URL}/options/check-in`, payload).then((r: AxiosResponse) => r.data)
  },

  checkIn: async (id) => {
    return axios.patch(`${QUEUE_COUNTERS_URL}/${id}/check-in`).then((r: AxiosResponse) => r.data)
  },

  checkOut: async () => {
    return axios.patch(`${QUEUE_COUNTERS_URL}/check-out`).then((r: AxiosResponse) => r.data)
  },
}
